/**
* @copyright
* Copyright(c) 2018 SICK AG
*/

const style = `
:host {
  box-sizing: border-box;
  display: flex;
  width: -moz-max-content;
  width: max-content;
  align-items: center;
  margin: 0 1.7142857143rem;
  height: 3.1428571429rem;
  font-size: 1rem;
  font-weight: 600;
  position: relative;
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
}

:host([hidden]) {
  position: fixed;
  right: -10000px;
}

.content-wrapper, .label {
  white-space: nowrap;
  display: inline-flex;
  height: 100%;
  align-items: center;
}

:host .label:hover {
  cursor: default;
}

:host(:not([disabled], [active])) .label:hover {
  cursor: pointer;
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
}

:host([disabled]) .label:hover {
  cursor: not-allowed;
}

:host([active]) {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}

:host([disabled]) {
  color: #C5CACC;
  color: var(--davinci-color-outline-light, #C5CACC);
}

:host([type=workflow][active]) .label {
  border-bottom-color: #007CC1;
  border-bottom-color: var(--davinci-color-primary, #007CC1);
}

:host([type=workflow][active][disabled]) .label {
  border-bottom-color: #C5CACC;
  border-bottom-color: var(--davinci-color-outline-light, #C5CACC);
}

:host([type=workflow]) {
  margin: 0 1.4285714286rem 0 0;
}
:host([type=workflow]) .label {
  height: 100%;
  border-bottom: calc(3rem /14) solid transparent;
}
:host([type=workflow]) davinci-icon-ref {
  margin-right: 1.4285714286rem;
  width: 1.2857142857rem;
  height: 1.2857142857rem;
  fill: #50585C;
  fill: var(--davinci-color-text-light, #50585C);
}

:host([type=workflow].first) {
  margin-left: 1.7142857143rem;
}

:host([type=workflow][disabled]) davinci-icon-ref {
  fill: #C5CACC;
  fill: var(--davinci-color-outline-light, #C5CACC);
}
`;
export { style };
